import { render } from "./LinkButton.vue?vue&type=template&id=242ec1d2"
import script from "./LinkButton.vue?vue&type=script&lang=js"
export * from "./LinkButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__